<div class="spen-ly-modal prod-upload">
  <div class="modal-dialog">
    <div class="inner">
      <div class="modal-heading">
        <h2 class="heading-text">アップロード中</h2>
      </div>
      <div class="modal-content has-footer">
        <div class="content-inner">
          <div class="prod-upload-container">
            <div class="mod-progress" role="modal-progress">
              <span class="progress-bar" role="modal-progress-bar" [style.width.%]="progress"></span>
            </div>
            <div class="calling-text prod-upload-text" role="modal-description">
              アップロードしています...<span>{{ progress }}</span
              >%
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="modal-actions is-right-actions">
          <button (click)="onCancel()" class="spen-mod-btn is-default">中断する</button>
        </div>
      </div>
    </div>
  </div>
</div>
